<div class="container-fluid p d-flex height-100-35 flex-column view_map" id="view_map">
  <div class="row flex-fill d-flex justify-content-center">

    <!-- Begin Mappa -->
    <div class="col-12 col-md-6 col-lg-7 map-wrapper p-0">
      <app-gmap #map (mapReady)="onMapReady()" (idle)="onIdle($event)"
        (pickedClicked)="onPickedClicked($event)" (markerClicked)="onMarkerClicked($event)"
        (clickedButton)="onClickMapButton($event)"></app-gmap>
    </div>
    <!-- End Mappa -->

		<!-- Begin Info -->
		<div class="col-12 col-md-6 col-lg-5 pt-3-5 scroll">
			<div class="page">
				<!-- Begin Titolo -->
				<div class="row d-flex justify-content-center align-items-center">
					<div class="col-8 mdi rounded titolo pb-3">
						<img
							src="./assets/imgs/ico-servizi-disponibili.png?v={{ assets_version }}"
							srcset="./assets/imgs/ico-servizi-disponibili@2x.png 2x"
							class="title-icon mr-2"
						/>
						<span>{{ title }}</span>
					</div>
					<div class="col-4 pb-3">
						<!-- <mat-spinner *ngIf="wait || waitBuildings"></mat-spinner> -->
						<!-- <mat-spinner *ngIf="waitBuildings"></mat-spinner> -->
					</div>
				</div>
				<!-- End Titolo -->

				<!-- Begin BEND -->
				<div class="card-block">
					<div class="d-flex align-items-center mb-2">
						<img src="{{ icon_pointB }}" class="align-self-center mr-3 pin-icon" alt="Pin" />
						<span>B-END</span>
					</div>

					<app-search-place
						#searchPlaceB
						(onSelected)="onSelectedPlace($event, 'B')"
						(onChangeCoordinatesFormat)="onChangeCoordinatesFormat($event, 'B')"
						(onSelectedCoordinates)="onSelectedCoordinates($event, 'B')"
						(isCoordinate)="typeSearchPlace.pointB = $event"
					></app-search-place>

					<div class="d-flex justify-content-between align-items-center my-2">
						<div class="divider"></div>
						<b class="text-uppercase mx-3">{{ "GENERAL.OR" | translate }}</b>
						<div class="divider"></div>
					</div>

					<div class="form-row">
						<app-select-poi
							*ngIf="poiList && poiList.length"
							#searchPoiB
							[list]="poiList"
							(onSelected)="onSelectedPoi($event, false, null, 'B')"
							class="w-100"
						></app-select-poi>
					</div>

					<ng-container>
						<div class="d-flex justify-content-between align-items-center my-2">
							<div class="divider"></div>
							<b class="text-uppercase mx-3">{{ "GENERAL.OR" | translate }}</b>
							<div class="divider"></div>
						</div>
						<p class="click-map-icon my-0 text-center">
							{{ "COVERAGE.CLICK_MAP" | translate }}
							<img
								class="align-self-center ml-3"
								src="{{ mapService.pathImgsMarkers }}/gmarker.png?v={{ assets_version }}"
								alt="Pin"
							/>
						</p>
					</ng-container>
				</div>
				<!-- End BEND -->

				<!-- Begin AEND -->
				<ng-container>
					<div class="card-block my-4">
						<div class="d-flex align-items-center mb-2">
							<img src="{{ icon_pointA }}" class="align-self-center mr-3 pin-icon" alt="Pin" />
							<span>A-END</span>
						</div>

						<div class="form-row">
							<app-select-poi
								*ngIf="poiList && poiList.length"
								#searchPoiA
								[list]="poiList"
								(onSelected)="onSelectedPoi($event, false, null, 'A')"
								class="w-100"
							></app-select-poi>
						</div>

						<div class="d-flex justify-content-between align-items-center my-2">
							<div class="divider"></div>
							<b class="text-uppercase mx-3">{{ "GENERAL.OR" | translate }}</b>
							<div class="divider"></div>
						</div>

						<app-search-place
							#searchPlaceA
							(onSelected)="onSelectedPlace($event, 'A')"
							(onChangeCoordinatesFormat)="onChangeCoordinatesFormat($event, 'A')"
							(onSelectedCoordinates)="onSelectedCoordinates($event, 'A')"
							(isCoordinate)="typeSearchPlace.pointA = $event"
						></app-search-place>

						<ng-container>
							<div class="d-flex justify-content-between align-items-center my-2">
								<div class="divider"></div>
								<b class="text-uppercase mx-3">{{ "GENERAL.OR" | translate }}</b>
								<div class="divider"></div>
							</div>
							<p class="click-map-icon my-0 text-center">
								{{ "COVERAGE.CLICK_MAP" | translate }}
								<img
									class="align-self-center ml-3"
									src="{{ mapService.pathImgsMarkers }}/gmarker.png?v={{ assets_version }}"
									alt="Pin"
								/>
							</p>
						</ng-container>
					</div>
				</ng-container>
				<!-- End AEND -->
				<!-- <mat-spinner class="mt-3" *ngIf="wait || waitBuildings"></mat-spinner> -->

				<div class="mt-3">
					<!-- Massive Import -->
					<div
						class="d-none card-block my-4"
						[class.d-block]="
							(mapService.isOpenFiberUser || mapService.isFastwebUser || mapService.isWindTreUser) &&
							!wait
						"
					>
						<div class="d-flex align-items-center mb-2">
							<i class="far fa-copy import-icon"></i>
							<span class="text-uppercase">Massive Submission</span>
						</div>
						<div class="input-file">
							<button mat-stroked-button (click)="downloadTemplate()">
								<span>Download template</span>
								<i class="far fa-file-excel input-file-icon"></i>
							</button>
						</div>
						<div class="d-flex justify-content-between align-items-center my-2">
							<div class="divider"></div>
							<b class="text-uppercase mx-3">{{ "GENERAL.OR" | translate }}</b>
							<div class="divider"></div>
						</div>
						<div class="input-file">
							<button mat-stroked-button (click)="mapService.open('uploadModal')">
								<span>Submit file</span>
								<i class="fas fa-file-import input-file-icon"></i>
							</button>
						</div>
					</div>

					<div class="d-none flex-column justify-content-center" [class.d-flex]="pointB && pointA && !wait">
						<ng-container *ngIf="mapService.isOpenFiberUser">
							<mat-form-field appearance="outline" class="w-100">
								<input
									#inputCompany
									type="text"
									placeholder="{{ 'MANAGEMENT.REQUESTING_COMPANY' | translate }}"
									matInput
									[formControl]="requestOfControl"
									[matAutocomplete]="autocompleteCompany"
								/>
								<mat-autocomplete #autocompleteCompany="matAutocomplete">
									<mat-option *ngFor="let option of filteredCompanies | async" [value]="option">
										{{ option }}
									</mat-option>
								</mat-autocomplete>
							</mat-form-field>
							<mat-form-field appearance="outline" class="w-100">
								<input
									matInput
									type="text"
									[(ngModel)]="project"
									placeholder="{{ 'MANAGEMENT.PROJECT' | translate }}"
									name="project"
								/>
							</mat-form-field>
						</ng-container>

						<ng-container *ngIf="pointB && pointA && !showResultBtn">
							<button
								[disabled]="mapService.isOpenFiberUser && !requestOfControl.value"
								mat-stroked-button
								class="btn mt-3 d-block"
								(click)="check('ETHERNET')"
							>
								{{ "GENERAL.CHECK_FEASIBILITY" | translate }}
							</button>
							<div class="d-flex justify-content-between align-items-center my-2">
								<div class="divider"></div>
								<b class="text-uppercase mx-3">{{ "GENERAL.OR" | translate }}</b>
								<div class="divider"></div>
							</div>
						</ng-container>

						<div
							*ngIf="pointB && pointB.typeForBe != 'POI' && pointA && pointA.typeForBe != 'POI'"
							class="mb-3"
						></div>

						<ng-container *ngIf="pointB && pointA && !showResultBtn">
							<button
								[disabled]="mapService.isOpenFiberUser && !requestOfControl.value"
								mat-stroked-button
								class="btn d-block"
								(click)="check('PASSIVE')"
							>
								{{ "GENERAL.FEAS_EVAL_PASSIVE" | translate }}
							</button>
							<div class="d-flex justify-content-between align-items-center my-2">
								<div class="divider"></div>
								<b class="text-uppercase mx-3">{{ "GENERAL.OR" | translate }}</b>
								<div class="divider"></div>
							</div>
						</ng-container>
					</div>

					<ng-container *ngIf="p2pResult && showResultBtn && !wait">
						<div class="d-flex flex-column justify-content-center">
							<button class="btn" mat-stroked-button (click)="mapService.open('resultModal')">
								{{ "GENERAL.SHOW_RESULT" | translate }}
							</button>
						</div>
						<div class="d-flex justify-content-between align-items-center my-2">
							<div class="divider"></div>
							<b class="text-uppercase mx-3">{{ "GENERAL.OR" | translate }}</b>
							<div class="divider"></div>
						</div>
					</ng-container>
				</div>

				<div class="d-flex flex-column justify-content-center">
					<button mat-stroked-button class="btn d-block" (click)="reset()">Reset</button>
				</div>
				<mat-spinner *ngIf="wait || waitBuildings"></mat-spinner>
			</div>
		</div>
	</div>
</div>

<app-modal-error [errorText]="errorTitle"></app-modal-error>
<app-result-modal
	[p2p]="p2pResult"
	[position1]="pointB"
	[position2]="pointA"
	[errorTitle]="errorTitle"
	[salesforceSent]="salesforceSent"
	[userData]="mapService.userData"
	[showSpinner]="waitSalesforce"
	(sendToSalesforce)="sendToSalesforce(p2pResult.id)"
></app-result-modal>
<app-modal-upload-file></app-modal-upload-file>
<app-modal-multi-building
	[buildings]="modalBuildings"
	[end]="modalEnd"
	(selectBuilding)="onClickBuilding($event)"
	(dismissModal)="onDismissModalMultiBuilding($event)"
></app-modal-multi-building>

<div
	*ngIf="showToast"
	aria-live="polite"
	aria-atomic="true"
	class="d-flex justify-content-center align-items-center parent-toast"
	style="min-height: 200px"
>
	<!-- Then put toasts within -->
	<div class="toast" role="alert" aria-live="assertive" aria-atomic="true">
		<div>
			<div class="toast-body">
				<p class="mt-2 mb-1">{{ temp_point.label }}</p>
				<p class="btn btn-sm save-whats-here mb-0" (click)="onSelectPlaceFromToast('B')">
					<span class="d-flex flex-column ligther">
						<img
							src="{{ mapService.pathImgsMarkers }}/picked_marker.png?v={{ assets_version }}"
							class="toast-image"
						/>
						<span class="mt-1">B-END</span>
					</span>
				</p>
				<p class="btn btn-sm save-whats-here-b mb-0" (click)="onSelectPlaceFromToast('A')">
					<span class="d-flex flex-column ligther">
						<img
							src="{{ mapService.pathImgsMarkers }}/picked_marker_p2p.png?v={{ assets_version }}"
							class="toast-image"
						/>
						<span class="mt-1">A-END</span>
					</span>
				</p>
			</div>
			<button
				type="button"
				class="ml-2 mb-1 close close-btn"
				data-dismiss="toast"
				aria-label="Close"
				(click)="closeToast()"
			>
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	</div>
</div>
